export default "__VITE_ASSET__DzyMgt5w__"